export default __webpack_public_path__ + "static/media/click2.a478b6d9.mp3";